import { hc } from "hono/client";
import type { AppType } from "../../../worker";

// Identity comes from URL params passed by the embedding site.
// `?userId=` — no param → local-only mode, no API calls.
// `?email=`  — optional, forwarded to the Worker for Klaviyo list sync.
const params = new URLSearchParams(window.location.search);
export const userId = params.get("userId");
export const email = params.get("email");

export type ApiClient = ReturnType<typeof hc<AppType>>;

// In tests, the harness can override globalThis.__NN_FETCH__ to route fetch
// through miniflare's in-process dispatcher. Production uses the real fetch.
type FetchImpl = typeof fetch;
declare global {
  // eslint-disable-next-line no-var
  var __NN_FETCH__: FetchImpl | undefined;
}

function makeApi(): ApiClient | null {
  if (!userId) return null;
  const fetchImpl = (globalThis.__NN_FETCH__ ??
    window.fetch.bind(window)) as FetchImpl;
  return hc<AppType>("/", { fetch: fetchImpl });
}

export const api: ApiClient | null = makeApi();
